<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
      <ul class="navbar-nav">
        <li class="nav-item">
          <sidenav-item
            url="/inicio"
            :class="getRoute() === 'inicio' ? 'active' : ''"
            navText="Início"
          >
            <template v-slot:icon>
              <i class="ni ni-tv-2 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/usuarios"
            :class="getRoute() === 'usuarios' ? 'active' : ''"
            navText="Usuários"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/categorias"
            :class="getRoute() === 'categorias' ? 'active' : ''"
            navText="Categorias de Notícia"
          >
            <template v-slot:icon>
              <i class="ni ni-tag text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/noticias"
            :class="getRoute() === 'noticias' ? 'active' : ''"
            navText="Notícias"
          >
            <template v-slot:icon>
              <i class="ni ni-single-copy-04 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/colunistas"
            :class="getRoute() === 'colunistas' ? 'active' : ''"
            navText="Colunistas"
          >
            <template v-slot:icon>
              <i class="ni ni-glasses-2 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/colunas"
            :class="getRoute() === 'colunas' ? 'active' : ''"
            navText="Colunas"
          >
            <template v-slot:icon>
              <i class="fa fa-columns text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/evento"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Eventos"
          >
            <template v-slot:icon>
              <i class="ni ni-calendar-grid-58 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/contos"
            :class="getRoute() === 'contos' ? 'active' : ''"
            navText="Contos"
          >
            <template v-slot:icon>
              <i class="ni ni-single-copy-04 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/parceiros"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Parceiros"
          >
            <template v-slot:icon>
              <i class="ni ni-single-02 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/categoria-propaganda"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Categorias de Proganda"
          >
            <template v-slot:icon>
              <i class="ni ni-tag text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/propagandas"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Propagandas"
          >
            <template v-slot:icon>
              <i class="ni ni-box-2 text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/categoria-negocio"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Categorias de Negócio"
          >
            <template v-slot:icon>
              <i class="ni ni-tag text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
        <li class="nav-item">
          <sidenav-item
            url="/negocio"
            :class="getRoute() === 'evento' ? 'active' : ''"
            navText="Negócios"
          >
            <template v-slot:icon>
              <i class="fa fa-briefcase text-dark text-lg opacity-10"></i>
            </template>
          </sidenav-item>
        </li>
      </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer">
    <sidenav-card
      :class="cardBg"
      textPrimary="Need Help?"
      textSecondary="Please check our docs"
    />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";

export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
    };
  },
  components: {
    SidenavItem,
    SidenavCard,
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
  },
};
</script>
<style scoped>
.navbar-vertical.bg-white .navbar-nav > .nav-item .nav-link.active {
  background-color: rgb(190, 190, 190);
  color: #000;
}
</style>
